export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-699afb7ce727a0ed731a7a42319668d6.svg";